import { env } from "config";
import { CurrencyCode } from "types/general";

/**
 * Payment service the paired backend instance uses. Selected at build/deploy
 * time via REACT_APP_PAYMENT_PROVIDER (chargebee | yookassa, default chargebee);
 * the backend exposes GET /v3/settings/payment for a runtime cross-check.
 *
 * In YooKassa mode the frontend never talks to a payment library: the backend
 * returns a paymentLink (YooKassa confirmation URL) and the browser is
 * redirected there.
 */
export enum PaymentProvider {
  CHARGEBEE = "chargebee",
  YOOKASSA = "yookassa",
}

export function getPaymentProvider(): PaymentProvider {
  const value = (env.REACT_APP_PAYMENT_PROVIDER || "").toString().toLowerCase();
  return value === PaymentProvider.YOOKASSA ? PaymentProvider.YOOKASSA : PaymentProvider.CHARGEBEE;
}

export function isYookassa(): boolean {
  return getPaymentProvider() === PaymentProvider.YOOKASSA;
}

export function isChargebee(): boolean {
  return getPaymentProvider() === PaymentProvider.CHARGEBEE;
}

/** Navigates to the YooKassa confirmation page in the current tab. */
export function redirectToPayment(paymentLink: string) {
  window.open(paymentLink, "_self");
}

/**
 * Currency used for price calculation and card payments when the user made no
 * explicit choice. YooKassa accepts card payments in RUB only; Chargebee
 * instances keep the historical USD default.
 */
export function getDefaultCurrencyCode(): CurrencyCode {
  return isYookassa() ? CurrencyCode.RUB : CurrencyCode.USD;
}
